<div class="container">
  <div *ngIf="!editCondition">
    <ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'"
      [opacity]="0.3" [spinner]="spinkit.skThreeBounce">
    </ng-http-loader>
    <div class="row" style="padding-top: 24px;">
      <div>
        <button (click)="backClicked()" style="border: none;background: transparent;"><img
            src="../../../../assets/img/Icon ionic-ios-arrow-back.svg" alt=""></button>
      </div>
      <div style="margin-left: 10px;" class="profile-head-conitainer">
        <div *ngIf="imgFlag">
          <div *ngFor="let userdatail of userdatails_array">
            <tc-avatar *ngIf="!userdatail.up_profile_image" [src]="defalutimage" [size]="90"></tc-avatar>
            <tc-avatar *ngIf="userdatail.up_profile_image" [src]="userdatail.up_profile_image" [size]="90"></tc-avatar>
          </div>
        </div>
        <tc-avatar *ngIf="!imgFlag" [src]="defalutimage" [size]="90"></tc-avatar>
        <div class="profile-head-userDeatils">
          <div class="userName userText" style="text-transform: capitalize;" *ngIf="userName_loggedin">
            {{userName_loggedin}}</div>
          <div class="userName" *ngIf="userEmail">{{userEmail}}</div>
          <div class="editUserProfile"><span style="cursor: pointer;" (click)="editProfle()">Edit profile</span> <img
              src="../../../../assets/img/editProfile.svg" alt="" style="padding-left: 8px;cursor: pointer;"
              (click)="editProfle()"></div>
        </div>
      </div>
    </div>

    <div class="border-line">
      &nbsp;
    </div>
    <div>
      <div style="margin-top: 10px; display:flex; justify-content:space-between;">
        <ng-container *ngIf="!taste_code">
          <div>
            <img src="../../../../assets/img/unique-taste-id.svg" alt="">
            <span class="btn-preference">Unique taste id</span>
          </div>
          <button class="buttonsgen" (click)="tasteidgenerate()" [style.background-color]="'#47941b'"
            [style.color]="'white'">Generate Taste Id </button>
        </ng-container>
      </div>
    </div>

    <div *ngIf="taste_code">
      <img src="../../../../assets/img/unique-taste-id.svg" alt="">
      <span class="btn-preference">Unique taste id</span>
      <span class="taste-code">{{taste_code}}
        <i class="fa fa-info-circle" aria-hidden="true"
          tooltip="The taste ID will help Foodbud to
              provide you with relevant food recommendations when you visit our partner restaurant, cafe or a pub and it will evolve as you make new food choices"></i>
        <img src="../../../../assets/img/Icon ionic-md-share.svg" alt="" style="margin-left: 10px; cursor:pointer"
          (click)="shareFrnFunc()">
      </span>
      <p class="text_bold">You are similar to <span class="bold"> {{taste_totalScore}} %</span> Foodbud users.</p>
    </div>

    <div class="d-flex preference-div">
      <div>
        <img src="../../../../assets/img/food_preference.svg" alt="" (click)="goToPreference()"
          style="cursor: pointer;">
        <button class="btn-preference" (click)="goToPreference()">My Food Preferences</button>
      </div>
      <div>
        <img src="../../../../assets/img/right-icons.svg" alt="" style="width: 8px;cursor: pointer;"
          (click)="goToPreference()">
      </div>
    </div>

    <div class="d-flex preference-div" style="cursor: pointer;" (click)="myOrder()">
      <div>
        <img src="../../../../assets/img/my-order-history.svg" alt="">
        <button class="btn-preference">My Order History</button>
      </div>
      <div>
        <img src="../../../../assets/img/right-icons.svg" alt="" style="width: 8px;">
      </div>
    </div>
    <div class="d-flex preference-div" style="cursor: pointer;" (click)="myFreind()">
      <div>
        <img src="../../../../assets/img/my-friends.svg" alt="">
        <button class="btn-preference">My Friends</button>
      </div>
      <div>
        <img src="../../../../assets/img/right-icons.svg" alt="" style="width: 8px;">
      </div>
    </div>

    <div style="margin-top: 13px;">
      <img src="../../../../assets/img/logout.svg" alt="" (click)="logout()" style="cursor: pointer;">
      <button class="logout-btn" (click)="logout()">Logout</button>
    </div>
  </div>
  <div *ngIf="editCondition">
    <ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'"
      [opacity]="0.3" [spinner]="spinkit.skThreeBounce">
    </ng-http-loader>
    <div class="row" style="padding-top: 24px;">
      <div>
        <button (click)="editProfle()" style="border: none;background: transparent;"><img
            src="../../../../assets/img/Icon ionic-ios-arrow-back.svg" alt=""></button>
      </div>
    </div>
    <div class="editMainDiv">
      <!-- <tc-avatar *ngIf="!userdatail.up_profile_image && !src" [src]="defalutimage" [size]="90"></tc-avatar>
      <tc-avatar *ngIf="userdatail.up_profile_image && !src" [src]="userdatail.up_profile_image" [size]="90">
      </tc-avatar> -->
      <tc-avatar [src]="src" [size]="90"></tc-avatar>
      <input type="file" accept="image/png,image/jpeg" (change)="onImageChange($event)" #fileInput_image hidden />
      <img src="../../../../assets/img/camera.svg" alt="" (click)="fileInput_image.click()" class="editChangeImg">
    </div>
    <div class="edit-form-div">
      <mat-form-field appearance="legacy" class="mat-input">
        <mat-label>FIRST NAME</mat-label>
        <input matInput placeholder="Placeholder" [(ngModel)]="editFirstName">
      </mat-form-field>
      <mat-form-field appearance="legacy" class="mat-input">
        <mat-label>LAST NAME</mat-label>
        <input matInput placeholder="Placeholder" [(ngModel)]="editLastName">
      </mat-form-field>
      <mat-form-field appearance="legacy" class="mat-input">
        <mat-label>UNIQUE TASTE ID</mat-label>
        <input matInput placeholder="Placeholder" [value]="taste_code" disabled>
      </mat-form-field>
      <mat-form-field appearance="legacy" class="mat-input">
        <mat-label>YOUR EMAIL</mat-label>
        <input matInput placeholder="Placeholder" [value]="editEmail" disabled>
      </mat-form-field>
      <mat-form-field appearance="legacy" class="mat-input">
        <mat-label>PHONE NUMBER</mat-label>
        <input matInput placeholder="Placeholder" [(ngModel)]="editPhone">
      </mat-form-field>
      <div class="edit-profile-address">
        <label>ADDRESS</label>
        <textarea name="" id="" rows="3" [(ngModel)]="editAddress" class="form-control"></textarea>
      </div>

      <div class="d-flex" style="margin-top: 14%; margin-bottom: 20px;">
        <div class="common closeBtn" (click)="editProfle()">Close</div>
        <div class="common submitBtn" (click)="updateUserProfile()">Update</div>
      </div>

    </div>

  </div>




  <!-- <div class="row row-class main_header">
    <div *ngIf="UserCondition" class="col-8">
      <span class="guests">Hi {{userName}} ! &nbsp;
        <a class="icofont-ui-home " style="color: red !important;" (click)="backHomeUser()"></a>
      </span>
    </div>

    <div *ngIf="!UserCondition" class="col-8">
      <span class="guests">Hi Guest ! &nbsp;
        <a class="icofont-ui-home " style="color: red !important;" (click)="backHomeGuest()"></a>
      </span>
    </div>
    <div *ngIf="UserCondition" class="col-4 back" (click)="logout()">
      <span class="icon icofont-logout"></span>
      Logout
    </div>
  </div> -->
  <!-- <div class="row" style="padding-top: 5px;">
    <div class="col-6">
      <span class="titles">Profile &nbsp;
        <i *ngIf="UserCondition" class="fa fa-pencil-square-o" style="color: #47941b !important; font-size: 20px;"
          tooltip="Click to view profile menu" aria-hidden="true" (click)="OnEditclick()"></i>
      </span>
    </div>
  </div> -->
  <!-- style="overflow: auto; height: 800px;  -->
  <!-- <div *ngIf="UserCondition" class="row justify-content-center ">
    <div *ngFor="let userdatail of userdatails_array">
      <form novalidate class="mb-4">
        <div class="row">
          <div class="col-3 py-2 ">
            <tc-form-group>
              <tc-avatar *ngIf="!userdatail.up_profile_image" [src]="defalutimage" [size]="90"></tc-avatar>
              <label for="fileInput">
                <tc-avatar *ngIf="userdatail.up_profile_image" tooltip="choose File" #myTooltip="tooltip"
                  [src]="userdatail.up_profile_image" [size]="90" class="image"></tc-avatar>
              </label>
              <br />
              <input id="fileInput" type='file' (change)="onImageChange($event)">
              <label for="fileInput">
                <p class="text_photo">Change photo</p>
              </label>
            </tc-form-group>
          </div>
          <div class="col-9 " style="padding-left: 20px; margin-top: 4%;">
            <div class="row row-class">
              <div class="col-12">
                <span class="username_text">{{userdatail.up_fname}}
                  {{userdatail.up_lname}}</span> &nbsp;&nbsp;
                <span *ngIf="userdatail.up_gender !='NA' &&  userdatail.up_gender == 'Man'">
                  <img class="img_gender" [src]="male" alt="notdis" width="14">
                </span>
                <span *ngIf="userdatail.up_gender !='NA' &&  userdatail.up_gender == 'Woman'">
                  <img class="img_gender" [src]="female" alt="notdis" width="14">
                </span>
              </div>
            </div>
            <div class="row row-class">
              <ui-switch size="small" [checked]=" userdatail.user_preference_cc == 'Yes' ? true : false"
                (change)="crossCon($event)"></ui-switch>
              &nbsp;
              <tc-form-label class="cross_text"> Avoid cross contamination</tc-form-label>
            </div>
            <tc-form-group *ngIf="userdatail.user_preference_spice">
              <div class="row row-class">
                <div class="col-4.5" style="margin-top: -4px;">
                  <span *ngFor="let value of count(userdatail.user_preference_spice)">
                    <img src="./assets/img/mirchi.png" alt="spiceimage" width="18">
                  </span>
                </div>
                <div class="col-6.5" style="padding-left: 10px;">
                  <tc-form-label style=" font-size: 13px;color: #6f706e;font-weight: 600;">Spice tolerance
                  </tc-form-label>
                </div>
              </div>
            </tc-form-group>
          </div>
        </div>
        <table style="width: 100%; margin-top: -5px; ">
          <tr align="center">
            <td style="width: 50%;">

              <p style=" font-size: 14px;color: #ff0000;font-weight: 600;">
                Food Allergies/Intolerance
              </p>
            </td>
            <td style="width: 50%;">
              <p style=" font-size: 14px;color: #47941b;font-weight: 600;">
                Dietary preferences
              </p>
            </td>
          </tr>
          <tr>
            <td align="center">
              <tc-form-group *ngIf="!userdatail.userAllergens">
                <h6 style="font-weight: 600; color: #6f706e;">Not Available</h6>
              </tc-form-group>
              <div class="mainpre py-4">
                <tc-form-group *ngIf="userdatail.userAllergens">
                  <ng-container *ngFor="let allergies of userdatail.userAllergens ; index as i">
                    <div *ngIf="i< 2 ">
                      <button class="buttonsallergy" [title]="allergies.allergens_name"
                        [style.background-color]="'#ff0000'" [style.color]="'white'">
                        <span>{{allergies.allergens_name}}</span> </button>&nbsp;&nbsp;
                    </div>
                  </ng-container>
                </tc-form-group>
              </div>
              <div class="More col-12 text-center " *ngIf="lengthallergens >2">
                <button class="moreTitle" (click)="onClickallergen()">More</button>
              </div>
            </td>
            <td align="center">
              <tc-form-group *ngIf="!userdatail.userDietary">
                <h6 style="font-weight: 600; color: #6f706e;">Not Available</h6>
              </tc-form-group>
              <div class="mainpre py-4">
                <tc-form-group *ngIf="userdatail.userDietary">
                  <ng-container *ngFor="let dietary of userdatail.userDietary; index as i">
                    <div *ngIf="i< 2 ">
                      <button class="buttonsdietary" [title]="dietary.diet_preference_name"
                        [style.background-color]="'#47941b'" [style.color]="'white'">{{dietary.diet_preference_name}}
                      </button>&nbsp;&nbsp;
                    </div>
                  </ng-container>
                </tc-form-group>
              </div>
              <div class=" More col-12 text-center " *ngIf="lengthdietary > 2">
                <button class="moreTitle" (click)="onClickdietary()">More</button>
              </div>
            </td>
          </tr>
        </table>
        <tc-form-group *ngIf="taste_code">
          <tc-form-label style=" font-size: 14px;color: #6f706e;font-weight: 600;  margin-top: -10px;">Unique taste id
          </tc-form-label>
          <p class="text_bold"> Your unique taste ID has been created as </p>
          <p class="bold"><span style="line-height: 0.1;">{{taste_code}}</span></p>
          <p class="text_bold">You are similar to <span class="bold"> {{taste_totalScore}} %</span> Foodbud users.</p>
        </tc-form-group>
        <tc-form-group *ngIf="taste_code" align="center">
          <ng-container>
            <button class="buttonsgen" [routerLink]="['../', 'sharefriends']" [style.background-color]="'#47941b'"
              [style.color]="'white'">Share with friends </button>
          </ng-container>
        </tc-form-group>
        <tc-form-group *ngIf="!taste_code" align="center">
          <ng-container>
            <button class="buttonsgen" (click)="tasteidgenerate()" [style.background-color]="'#47941b'"
              [style.color]="'white'">Generate Taste Id </button>
          </ng-container>
        </tc-form-group>
        <div class="row options">
          <div class="col-12 col-sm-4">
            <a [routerLink]="['../', 'edit-profile']" (click)="onDetails()">My details
              <span style="float: right;">
                <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
              </span>
            </a>
            <hr style="width: 100%; color: black; margin-top: 10px;">
          </div>
          &nbsp;
          <div class="col-12 col-sm-4" [routerLink]="['../', 'edit-profile']">
            <a [routerLink]="['../', 'edit-profile']" (click)="onPreferences()"> My food Preferences
              <span style="float: right;">
                <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
              </span>
            </a>
            <hr style="width: 100%; color: black; margin-top: 10px;">
          </div>
          &nbsp;
          <div class="col-12 col-sm-4" [routerLink]="['../', 'order-list']">
            <a [routerLink]="['../', 'order-list']">My orders history
              <span style="float: right;">
                <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
              </span>
            </a>
            <hr *ngIf="taste_code" style="width: 100%; color: black; margin-top: 10px;">
          </div>
          <div class="col-12 col-sm-4" *ngIf="taste_code">
            <a [routerLink]="['../', 'friends']">My friends
              <span style="float: right;">
                <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
              </span>
              <hr style="width: 100%; color: black; margin-top: 10px;">
            </a>
          </div>
          <div class="col-12 col-sm-4" *ngIf="taste_code">
            <a [routerLink]="['../', 'sharefriends']">Share with your friends
              <span style="float: right;">
                <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
              </span>
            </a>
          </div>
        </div>
      </form>
    </div>
  </div> -->



  <!-- <div *ngIf="UserCondition"  class="row justify-content-center py-2" style="overflow: auto; height: 800px; width: 98%; ">
    <div class="col col-12 col-xl-10" *ngFor ="let userdatail of userdatails_array">
      <form novalidate class="mb-4">
        <tc-form-group >
          <div align ="center">
            <tc-avatar [src]="userdatail.up_profile_image" [size]="100"></tc-avatar>
            <h4> <span style=" font-size: 22px;color: #47941b;font-weight: 600;">{{userdatail.up_fname}} {{userdatail.up_lname}}</span> 
              <br>
              <span style=" font-size: 14px;color: #2d2e2c;font-weight: 600;">{{userdatail.up_gender}}</span>
            </h4>
          </div>
        </tc-form-group> 
        <tc-form-group>
          <div    class="row row-class" style="font-weight: 600; color: #6f706e;" > 
            <ui-switch size="small"  [checked]=" userdatail.user_preference_cc == 'Yes' ? true : false" ></ui-switch>
            &nbsp; &nbsp; Avoid cross contamination user   
         </div>
        </tc-form-group>
        <tc-form-group *ngIf ="!userdatail.userAllergens">
          <tc-form-label style=" font-size: 14px;color: #ff0000;font-weight: 600;">Food Allergies/Intolerance</tc-form-label>
           <h6 style="font-weight: 600; color: #6f706e;">Not Available</h6>
        </tc-form-group>

        <tc-form-group *ngIf ="userdatail.userAllergens">
          <tc-form-label style=" font-size: 14px;color: #ff0000;font-weight: 600;">Food Allergies/Intolerance</tc-form-label>
          <ng-container *ngFor ="let allergies of userdatail.userAllergens">
            <button class="buttonsallergy" [title]="allergies.allergens_name" [style.background-color] = "'#47941b'" [style.color] = "'white'">{{allergies.allergens_name}} </button>&nbsp;&nbsp;
         </ng-container>        
        </tc-form-group>

        <tc-form-group *ngIf ="!userdatail.userDietary">
          <tc-form-label style=" font-size: 14px;color: #47941b;font-weight: 600;">Dietary preferences</tc-form-label>
           <h6 style="font-weight: 600; color: #6f706e;">Not Available</h6>
        </tc-form-group>
        <tc-form-group *ngIf ="userdatail.userDietary">
          <hr>
          <br>
          <tc-form-label style=" font-size: 14px;color: #47941b;font-weight: 600;">Dietary preferences</tc-form-label>
          <ng-container *ngFor ="let dietary of userdatail.userDietary">
            <button class="buttonsdietary" [title]="dietary.diet_preference_name" [style.background-color] = "'#ff0000'" [style.color] = "'white'">{{dietary.diet_preference_name}} </button>&nbsp;&nbsp;
         </ng-container>          
        </tc-form-group>
        <hr>
        <br>
        <tc-form-group>
          <tc-form-label style=" font-size: 14px;color: #6f706e;font-weight: 600;">Spice tolerance</tc-form-label>
          <span *ngFor ="let value of count(userdatail.user_preference_spice)">
            <img src="./assets/img/mirchi.png" alt="spiceimage" width="18">
          </span>
        </tc-form-group>    
        <tc-form-group *ngIf = "taste_code">
          <hr>
          <br>
        <tc-form-label style=" font-size: 14px;color: #6f706e;font-weight: 600;">Unique taste id</tc-form-label>
        <p> your unique taste ID has been created as </p>
        <p class="bold" ><span style="line-height: 0.1;">{{taste_code}}</span></p>
        <p>you are similar to <span class="bold"> {{taste_totalScore}} %</span>  people on our platform.</p>
        </tc-form-group>
        <tc-form-group *ngIf ="taste_code" align="center">
          <ng-container>
            <button class="buttonsgen" [routerLink]="['../', 'sharefriends']" [style.background-color] = "'#47941b'" [style.color] = "'white'">Share with friends </button>
         </ng-container>        
        </tc-form-group>
        <tc-form-group *ngIf ="!taste_code" align="center">
          <ng-container>
            <button class="buttonsgen" (click)="tasteidgenerate()" [style.background-color] = "'#47941b'" [style.color] = "'white'">Generate Taste Id </button>
         </ng-container>        
        </tc-form-group>
      </form>
    </div>
  </div> -->
  <!-- <div class="row" *ngIf="!UserCondition" style="padding-top: 50%;justify-content: center;">
    <div class="col-10">
      <button tc-button (click)="backTologin()">Login to view the profile</button> <br>
    </div>
  </div> -->
  <!-- <div class="row" *ngIf="!UserCondition" style=" padding-top:80px;justify-content: center;">
    <div><a [routerLink]="['../', 'food-menu-guest']">
        <span class="moreTitle_profile">
          Back to menu
        </span> </a>
    </div>
  </div> -->
  <br>
  <br>
  <br>
  <app-bottommenu></app-bottommenu>
</div>